import { render } from "./Create_Individual.vue?vue&type=template&id=6c2fedde&scoped=true"
import script from "./Create_Individual.vue?vue&type=script&lang=js"
export * from "./Create_Individual.vue?vue&type=script&lang=js"

import "./Create_Individual.vue?vue&type=style&index=0&id=6c2fedde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2fedde"]])

export default __exports__